import React from 'react';

const GlobalLoader = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="global-loader" role="status" aria-live="polite" aria-label="Loading">
      <div className="global-loader__dots">
        <span className="global-loader__dot dot-1" />
        <span className="global-loader__dot dot-2" />
        <span className="global-loader__dot dot-3" />
        <span className="global-loader__dot dot-4" />
      </div>
    </div>
  );
};

export default GlobalLoader;
